var _ellipse, _path, _path2, _ellipse2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.12504,
    cy: 3.37502,
    rx: 2.25004,
    ry: 1.12502,
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 3.5625V9.00011C6.375 10.4499 7.55028 11.6252 9.00005 11.6252V11.6252C10.4498 11.6252 11.6251 10.4499 11.6251 9.00011V3.375",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 3.375V9.00011C1.875 12.9352 5.06504 16.1253 9.00014 16.1253V16.1253C12.9352 16.1253 16.1253 12.9352 16.1253 9.00011V3.375",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.8752,
    cy: 3.37502,
    rx: 2.25004,
    ry: 1.12502,
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTube);
export default __webpack_public_path__ + "static/media/ic_tube.8ae07e90846bcd694ac0bee0824a6065.svg";
export { ForwardRef as ReactComponent };